export const formCivilityOptions = [
  { label: 'M.', value: 'Mr' },
  { label: 'Mme', value: 'Ms' },
  { label: 'Mlle', value: 'Mrs' },
];
export const formGenderOptions = [
  { label: 'Male', value: 'male' },
  { label: 'Female', value: 'female' },
];
